import {
  BarChart3,
  BookOpen,
  ClipboardCheck,
  CreditCard,
  History,
  Layers3,
  LayoutDashboard,
  Megaphone,
  MessageSquare,
  MessagesSquare,
  Radio,
  ReceiptText,
  Trophy,
  Users,
  type LucideIcon
} from 'lucide-react'

export type HeaderMenuItem = {
  label: string
  path: string
  activePaths?: string[]
  children?: HeaderMenuItem[]
}

export type AdminNavItem = {
  label: string
  path: string
  icon: LucideIcon
}

export const getHeaderNavigation = (): HeaderMenuItem[] => {
  const participationChildren: HeaderMenuItem[] = [
    { label: '퀴즈', path: '/quiz', activePaths: ['/quiz'] }
  ]

  return [
    {
      label: '강의실',
      path: '/courses',
      activePaths: [
        '/courses',
        '/course/',
        '/lesson/',
        '/audio-courses',
        '/audio-course/',
        '/project-live-courses',
        '/offline-courses'
      ],
      children: [
        { label: '프로젝트 강좌', path: '/courses', activePaths: ['/courses', '/course/', '/lesson/'] },
        { label: '프로젝트 강좌 (음성버전)', path: '/audio-courses', activePaths: ['/audio-courses', '/audio-course/'] },
        { label: '프로젝트 Live 강좌', path: '/project-live-courses' },
        { label: '프로젝트 오프라인 강좌', path: '/offline-courses' }
      ]
    },
    { label: '트심', path: '/trading-sim' },
    {
      label: '특강',
      path: '/course/4',
      activePaths: ['/course/4', '/theory-special', '/theory-special/', '/jeonban-jongji', '/ganjang-jongji', '/huban-jongji'],
      children: [
        { label: '트렌드2026', path: '/course/4', activePaths: ['/course/4'] },
        { label: '이론특강', path: '/theory-special', activePaths: ['/theory-special', '/theory-special/'] },
        { label: '전반종지', path: '/jeonban-jongji', activePaths: ['/jeonban-jongji', '/ganjang-jongji'] },
        { label: '후반종지', path: '/huban-jongji' },
        { label: '학기제 라이브', path: '/course/18' }
      ]
    },
    {
      label: '커뮤니티',
      path: '/live',
      activePaths: ['/live', '/forum'],
      children: [
        { label: '라이브', path: '/live', activePaths: ['/live'] },
        { label: '공지사항', path: '/forum/notice', activePaths: ['/forum/notice'] },
        { label: 'Q&A', path: '/forum/qna', activePaths: ['/forum/qna'] },
        { label: '자유게시판', path: '/forum/free', activePaths: ['/forum', '/forum/free'] }
      ]
    },
    {
      label: '참여',
      path: participationChildren[0].path,
      activePaths: ['/quiz'],
      children: participationChildren
    },
    { label: '결제', path: '/payment' }
  ]
}

export const ADMIN_NAV_ITEMS: AdminNavItem[] = [
  { label: '대시보드', path: '/admin/dashboard', icon: LayoutDashboard },
  { label: '승인 관리', path: '/admin/apply', icon: ClipboardCheck },
  { label: '회원 관리', path: '/admin/user', icon: Users },
  { label: '그룹 관리', path: '/admin/group', icon: Layers3 },
  { label: '강좌 관리', path: '/admin/course', icon: BookOpen },
  { label: '시청 시간 순위', path: '/admin/watch-time-ranking', icon: Trophy },
  { label: '진도율 관리', path: '/admin/progress', icon: BarChart3 },
  { label: '라이브 관리', path: '/admin/live', icon: Radio },
  { label: '전반종지 관리', path: '/admin/jeonban-jongji', icon: Layers3 },
  { label: '댓글 관리', path: '/admin/comment', icon: MessageSquare },
  { label: '커뮤니티 관리', path: '/admin/community', icon: MessagesSquare },
  { label: '팝업 공지 관리', path: '/admin/popup-notice', icon: Megaphone },
  { label: '퀴즈 관리', path: '/admin/quiz', icon: ClipboardCheck },
  { label: '로그인 이력', path: '/admin/login-history', icon: History },
  { label: 'PG 수기결제', path: '/admin/payment', icon: CreditCard },
  { label: '정기결제 관리', path: '/admin/billing', icon: ReceiptText }
]
